import React, { Component } from 'react'
import styles from './css/ExternalCompaniesComp.module.css';

export class ExternalCompaniesComp extends Component {
    render() {
        return (
            <div className={styles.externalCompaniesComp}>
                <div className={styles.externalCompaniesCompInner}>
                    <div className={styles.listOfCompanies}>
                        <div className={styles.company}>
                            <img src="/assets/logo/airbnb.png" />
                        </div>
                        <div className={styles.company}>
                            <img src="/assets/logo/Booking.com.png" />
                        </div>
                        <div className={styles.company}>
                            <img src="/assets/logo/Google.png" />
                        </div>
                        <div className={styles.company}>
                            <img src="/assets/logo/expedia.png" />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ExternalCompaniesComp
